"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _shouldUpdate = _interopRequireDefault(require("recompose/shouldUpdate"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports["default"] = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$validate = _ref.validate,
    validate = _ref$validate === void 0 ? function () {} : _ref$validate,
    _ref$fields = _ref.fields,
    fields = _ref$fields === void 0 ? ['value'] : _ref$fields;
  return function (WrappedComponent) {
    var _Component, _Component2;
    var ReduxForm = (0, _reduxForm.reduxForm)({})((_Component = /*#__PURE__*/function (_React$Component) {
      _inherits(Component, _React$Component);
      function Component() {
        _classCallCheck(this, Component);
        return _callSuper(this, Component, arguments);
      }
      _createClass(Component, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this$props = this.props,
            valid = _this$props.valid,
            errors = _this$props.errors;
          if (!valid) {
            this.props.onError(errors.value);
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this$props2 = this.props,
            valid = _this$props2.valid,
            values = _this$props2.values,
            errors = _this$props2.errors;
          if (this.props.originalProps.isValidating && this.props.originalProps.isValidating !== prevProps.originalProps.isValidating) {
            this.props.touchAll();
          }

          // Return new values or errors
          if (prevProps.valid === valid && prevProps.values === values) {
            return;
          }
          if (!valid) {
            this.props.onError(errors.value);
          } else {
            this.props.onUpdate(values.value);
          }
        }
      }, {
        key: "render",
        value: function render() {
          return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({
            field: this.props.fields.value
          }, (0, _omit2["default"])(this.props.originalProps, ['initialValues', 'form', 'isValidating', 'onUpdate', 'onError'])));
        }
      }]);
      return Component;
    }(_react["default"].Component), _defineProperty(_Component, "propTypes", {
      registerAction: _propTypes["default"].func,
      originalProps: _propTypes["default"].object,
      fields: _propTypes["default"].object,
      touchAll: _propTypes["default"].func.isRequired,
      onUpdate: _propTypes["default"].func,
      onError: _propTypes["default"].func,
      values: _propTypes["default"].object,
      valid: _propTypes["default"].bool,
      errors: _propTypes["default"].object
    }), _defineProperty(_Component, "defaultProps", {
      registerAction: function registerAction() {},
      originalProps: {}
    }), _Component));
    return (0, _shouldUpdate["default"])(function (props, nextProps) {
      // Update only if it's a preview mode or settings or template or templateExtraProps have been changed
      return props.isPreview || !(0, _isEqual2["default"])(props.settings, nextProps.settings) || props.isValidating !== nextProps.isValidating || props.isFeedbackMode !== nextProps.isFeedbackMode || !(0, _isEqual2["default"])(props.templateExtraProps, nextProps.templateExtraProps) || !(0, _isEqual2["default"])(props.accommodations, nextProps.accommodations) || !(0, _isEqual2["default"])((0, _get2["default"])(props, 'playerTemplateProps.playingActions'), (0, _get2["default"])(nextProps, 'playerTemplateProps.playingActions')) || props.template !== nextProps.template;
    })((_Component2 = /*#__PURE__*/function (_React$Component2) {
      _inherits(Component, _React$Component2);
      function Component() {
        var _this;
        _classCallCheck(this, Component);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _callSuper(this, Component, [].concat(args));
        _defineProperty(_assertThisInitialized(_this), "_validate", function (values) {
          var errors = {};
          var error = validate(values.value, _this.props.settings, _this.props.children);
          if (error) {
            errors.value = error;
          }
          return errors;
        });
        _defineProperty(_assertThisInitialized(_this), "_getFields", function () {
          if ((0, _isFunction2["default"])(fields)) {
            return fields(_this.props.settings);
          }
          return fields;
        });
        return _this;
      }
      _createClass(Component, [{
        key: "render",
        value: function render() {
          return /*#__PURE__*/_react["default"].createElement(ReduxForm, {
            originalProps: this.props,
            form: this.props.form,
            initialValues: this.props.initialValues,
            validate: this._validate,
            readonly: this.props.isPreview,
            fields: this._getFields(),
            onUpdate: this.props.onUpdate,
            onError: this.props.onError,
            overwriteOnInitialValuesChange: this.props.isPreview
          });
        }
      }]);
      return Component;
    }(_react["default"].Component), _defineProperty(_Component2, "propTypes", {
      form: _propTypes["default"].string,
      settings: _propTypes["default"].object,
      initialValues: _propTypes["default"].object,
      isPreview: _propTypes["default"].bool,
      onUpdate: _propTypes["default"].func,
      onError: _propTypes["default"].func,
      children: _propTypes["default"].array
    }), _defineProperty(_Component2, "defaultProps", {
      form: 'playerForm',
      settings: {},
      initialValues: {},
      isPreview: false,
      onUpdate: function onUpdate() {},
      onError: function onError() {}
    }), _Component2));
  };
};